/**
 * Replace dynamic tokens in text with their actual values
 * @param text - The text containing tokens to replace
 * @returns The text with all tokens replaced
 */
export function replaceTextTokens(text: string | undefined | null): string | undefined {
  if (text == null || text === '') return text ?? undefined

  const currentYear = new Date().getFullYear()

  return text.replace(/\[\[year\]\]/g, currentYear.toString())
}
